<div style="display: flex; width: 100%; height: calc(100% - 10px);">
    <app-guide-container [source]='source'></app-guide-container>
    <app-educational-container [source]='source'></app-educational-container>
    <!-- <div class="button-container">
      <button class="button empty-button" (click)="back()">Back</button>
      <button [ngClass]="{ 'disabled-button' : this.formService.userObjectForm.valid === false }" class="button filled-green-button" (click)="redirectEduCategoriesPage()">Continue</button>
    </div> -->
  </div>